// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-your-language{font-size:40px;font-weight:700;text-align:center;margin-bottom:50px}@media screen and (max-width:1200px){.select-your-language{font-size:3.5vw;font-weight:700;text-align:center;margin-bottom:50px}}.circle{padding:6%;border-radius:50%;background-color:#fff;border:1px solid #666;cursor:pointer;text-align:center}.circle img{width:100%}.circle:hover{border:2px solid #666}.circle:active{border:3px solid #999}", ""]);
// Exports
module.exports = exports;
